import React, { useEffect } from 'react';

export default function AuthCallback() {
  useEffect(() => {
    // `cancelled` impedisce alla seconda invocazione di StrictMode
    // di sovrascrivere la navigazione già avviata dalla prima.
    let cancelled = false;

    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (token) {
      // Flag consumato da SocietaContext per mostrare la modale di conferma società al login
      sessionStorage.setItem('bop_login_needs_confirm', '1');
      localStorage.setItem('token', token);
      if (!cancelled) window.location.replace('/dashboard');
    } else if (localStorage.getItem('token')) {
      if (!cancelled) window.location.replace('/dashboard');
    } else {
      if (!cancelled) window.location.replace('/');
    }

    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="bop-auth-callback">
      <div className="bop-auth-callback__content">
        <div className="bop-auth-callback__spinner" />
        <p className="bop-auth-callback__text">
          Accesso in corso…
        </p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
